import React, { useContext, useCallback, useState, useLayoutEffect } from 'react'
import { AuthContext } from '@/layout/Auth'
import { NotificationContext } from '@/layout/NotificationIO'
import { useNavigate } from 'react-router-dom'
import { Button, MenuItem } from '@mui/material'
import Icon from '@/components/Icon'
import { FloaterWrapper, Row, InfoCardBase, OrgDisplay, OrgsCard, OrgIcon, OrgCard } from './components'
import { Box, Stack } from '@mui/material'
import { useParams } from 'react-router-dom'
import Text from '@/components/Text'
import { grayText2, primary, defaultText } from '@/constant'
import { LogoWhite } from '@/icon'
import { getUserInfo, getUserOrganizations, setDefaultOrg } from '@/api'
import { useQuery, useMutation } from '@tanstack/react-query'
import AppPanel from './appPanel'
import UserPanel from './userPanel'
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded'
import { Organizationinfo } from '@/types'
import { userBg } from '@/utils'
import Assistant from './assistant'
import CounterBadge from '@/components/CounterBadge'
import { Message } from '@cx/ui'
import { redirectToBindIfNeeded } from '@/utils'

const FloatNav: React.FC<unknown> = () => {
  const { app_key = '' } = useParams()
  const appKeyArr = app_key.split('-')
  const org_id = appKeyArr[appKeyArr.length - 1]
  const { authInfo, updateAuthInfo } = useContext(AuthContext)
  const { notificatioinData } = useContext(NotificationContext)
  const navigate = useNavigate()
  const orgInfo = authInfo?.orgInfo
  const userInfo = authInfo?.userInfo
  const [hover, setHover] = useState<boolean>(false)

  const [openOrg, setOpenOrg] = useState<boolean>(false)
  const [orgWrapperOverflow, setOrgWrapperOverflow] = useState<boolean>(false)

  const initUserOrgInfo = () => {
    return Promise.all([getUserInfo(), getUserOrganizations()])
  }

  const defaultOrg = useMutation(setDefaultOrg, {
    onSuccess: () => {
      Message.success('切换空间成功')
      refetch()
    },
    onError: () => {
      refetch()
    },
  })

  const { data, refetch } = useQuery(['getFloatNavInitUserOrgData'], initUserOrgInfo, {
    onSuccess: ([user, orgData]) => {
      if (redirectToBindIfNeeded(user?.phone)) {
        return
      }
      const orgId = isNaN(Number(org_id)) ? user.org_id : +org_id
      updateAuthInfo({
        auth: true,
        userInfo: user,
        verified: user?.is_certified === 1,
        orgInfo: orgData?.data.find((org) => org.id === orgId) || orgData?.data?.[0],
      })
    },
    onError: () => {
      updateAuthInfo({
        auth: false,
        userInfo: null,
        verified: false,
        orgInfo: null,
      })
    },
    refetchOnWindowFocus: true,
  })

  // const { data, refetch } = useQuery(
  //   ["getUserOrganizationsFromApp", authInfo?.userInfo?.id],
  //   () => getUserOrganizations(),
  //   {
  //     refetchOnMount: false,
  //     onSuccess: (result) => {
  //       if (currentOrgId) {
  //         updateAuthInfo({
  //           orgInfo: result?.data?.find((org) => org.id === currentOrgId),
  //         });
  //       } else {
  //         updateAuthInfo({
  //           orgInfo: result?.data?.[0],
  //         });
  //       }
  //     },
  //     onError: () => {
  //       updateAuthInfo({
  //         orgInfo: null,
  //       });
  //     },
  //   }
  // );

  // useQuery(["getUserInfo"], getUserInfo, {
  //   onSuccess: (result) => {
  //     updateAuthInfo({
  //       auth: true,
  //       userInfo: result,
  //     });
  //   },
  //   onError: () => {
  //     updateAuthInfo({
  //       auth: false,
  //       userInfo: null,
  //       verified: false,
  //       orgInfo: null,
  //     });
  //   },
  //   refetchOnWindowFocus: true,
  // });

  const toWorkbench = useCallback(() => {
    setDefaultOrg({ ID: +org_id }).then(() => {
      navigate('/console/workbench')
    })
  }, [navigate, org_id])

  const toHome = useCallback(() => {
    navigate('/')
  }, [navigate])

  const toInvite = useCallback(() => {
    setDefaultOrg({ ID: +org_id }).then(() => {
      window.open('/console/space/base', '_blank')
    })
  }, [org_id])

  const onMouseEnter = useCallback(() => {
    setHover(true)
  }, [])

  const onMouseLeave = useCallback(() => {
    setHover(false)
    setOpenOrg(false)
    setOrgWrapperOverflow(false)
    // setClick(false);
  }, [])

  const onClickOrg = useCallback((event: React.MouseEvent) => {
    const target = event?.target as HTMLDivElement
    target.focus()
    setOpenOrg(true)
    setOrgWrapperOverflow(true)
  }, [])

  const closeOrgCard = useCallback(() => {
    setOpenOrg(false)
  }, [])

  const onOrgCardBlur = useCallback(
    (event: React.MouseEvent) => {
      const target = event?.target as HTMLDivElement
      target.blur()
      closeOrgCard()
      setTimeout(() => {
        setOrgWrapperOverflow(false)
      }, 100)
    },
    [closeOrgCard],
  )
  const onChangeOrg = (newOrg: Organizationinfo) => {
    defaultOrg.mutateAsync({ ID: newOrg.id }).then(() => {
      const regex = /console\/app\/([^\/]+)\-(\d+)/
      const str = window.location.pathname
      const match = str.match(regex)
      if (match) {
        const newStr = `/console/app/${match[1]}-${newOrg.id}`
        window.open(newStr, '_blank')
      }
    })
  }

  useLayoutEffect(() => {
    if (orgInfo?.id) {
      closeOrgCard()
      setTimeout(() => {
        setOrgWrapperOverflow(false)
      }, 100)
    }
    return () => {
      setHover(false)
    }
    //eslint-disable-next-line
  }, [orgInfo?.id])

  return (
    <>
      <FloaterWrapper open={hover ? 'true' : 'false'} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className='floater-nav'>
          <LogoWhite sx={{ fontSize: '22px' }} />
        </div>
        {/* <CounterBadge className='flouter-badge' max={99} number={notificatioinData?.total_number} /> */}

        <Box className='floater-panel'>
          <InfoCardBase>
            {authInfo?.auth ? (
              <Stack
                sx={{
                  height: '100%',
                  overflow: openOrg ? 'hidden' : 'auto',
                }}
                justifyContent='space-between'
              >
                <Stack sx={{ height: '100%' }} gap={1}>
                  <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ zIndex: 2 }}>
                    <Box
                      sx={{
                        fontWeight: 600,
                        maxWidth: 200,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {orgInfo?.name}
                    </Box>
                    <Button
                      variant='contained'
                      sx={{
                        width: 112,
                        height: 40,
                      }}
                      endIcon={<ArrowCircleRightRoundedIcon sx={{ color: 'rgba(255,255,255, 0.5)' }} />}
                      onClick={toWorkbench}
                    >
                      工作台
                    </Button>
                  </Stack>
                  <Row sx={{ justifyContent: 'space-between', zIndex: 2, mt: 2 }}>
                    <Text size='xs' sx={{ color: grayText2, fontSize: '14px' }}>
                      切换空间
                    </Text>

                    <Button variant='text' onClick={toInvite} size='small'>
                      邀请用户
                    </Button>
                  </Row>
                  <Stack
                    sx={{
                      backgroundColor: '#fff',
                      py: 1,
                      overflow: 'auto',
                      minHeight: 88,
                      maxHeight: 'calc(100vh - 510px)',
                      borderRadius: 1,
                    }}
                  >
                    {data?.[1]?.data?.map((org, index) => (
                      <MenuItem
                        key={org.id}
                        value={org.id}
                        selected={org.id === orgInfo?.id}
                        onClick={() => onChangeOrg(org)}
                        sx={{
                          mb: 0.5,
                          height: 40,
                          justifyContent: 'space-between',
                          '&:hover': {
                            '.workbench-app-edit': {
                              display: 'flex',
                            },
                          },
                          '&.Mui-selected': {
                            color: 'primary.main',
                            '.workbench-app-icon': {
                              color: '#A0C9FF',
                            },
                          },
                          '&:last-child': {
                            mb: 0,
                          },
                        }}
                      >
                        <Stack direction='row' gap={1.5} alignItems='center' sx={{ width: '100%' }}>
                          <Stack
                            justifyContent='center'
                            alignItems='center'
                            className='workbench-app-icon-wrapper'
                            sx={{
                              width: 24,
                              height: 24,
                              border: '1px solid #EEEEEE',
                              background: '#fff',
                              borderRadius: 1,
                            }}
                          >
                            <Icon
                              type='icon-kongjianzuzhi'
                              className='workbench-app-icon'
                              sx={{ color: 'rgba(0,0,0,0.2)' }}
                            />
                          </Stack>

                          <Box
                            sx={{
                              fontSize: 14,
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              width: 'calc(100% - 32px)',
                            }}
                          >
                            {org.name}
                          </Box>
                        </Stack>
                      </MenuItem>
                    ))}
                  </Stack>
                </Stack>

                {/*   @ts-ignore */}
                {/* <AppPanel orgInfo={orgInfo} userInfo={userInfo} /> */}
                <UserPanel
                  // @ts-ignore
                  userInfo={userInfo}
                  verified={authInfo?.verified}
                  unreadCount={notificatioinData?.total_number}
                />
              </Stack>
            ) : (
              <Stack sx={{ height: '100%', justifyContent: 'flex-start' }}>
                <Button variant='text' sx={{ marginTop: 'auto', minWidth: 'auto', padding: '0' }} onClick={toHome}>
                  返回首页
                </Button>
              </Stack>
            )}
          </InfoCardBase>
        </Box>
      </FloaterWrapper>
      <Box
        sx={{
          display: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: 0,
          height: '100vh',
          width: '100vw',
          transition: 'all 0.2s ease-in-out',
          ...(hover && {
            display: 'block',
            background: 'rgba(0,0,0,0.2)',
            opacity: 1,
            backdropFilter: 'blur(2px)',
            transition: 'all 0.2s ease-in-out',
          }),
        }}
      />
      {/* <Assistant /> */}
    </>
  )
}

export default FloatNav
